import { render, staticRenderFns } from "./UpdateAddressbook.vue?vue&type=template&id=9fd32b70&"
import script from "./UpdateAddressbook.vue?vue&type=script&lang=js&"
export * from "./UpdateAddressbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports